export default __webpack_public_path__ + "static/water-16fa2222115c70610c7d3fdd3d48d72f.jpg";